module.exports = __webpack_public_path__ + "img/logo.b7e4e822.png";